const pagesNetworksEn = {
  list: {
    pageTitle: "Networks",
    addNetwork: "Add Network",
    filterPlaceholder: "Filter by network name",
    tabs: {
      all: "All",
      sharedInternal: "Shared Internal",
      personalUse: "Personal Use",
      companyAsset: "Company Asset",
      customerEnvironment: "Customer Environment",
    },
  },
  add: {
    title: "Add Network",
    step1: {
      title: "Network Basic Information",
      networkName: {
        label: "Network Name",
        placeholder: "Enter network name",
      },
      networkType: {
        label: "Network Type",
        placeholder: "Select network type",
      },
      connectionType: {
        label: "Wired/Wireless",
        placeholder: "Select wired/wireless",
      },
      networkCategory: {
        label: "Network Category",
        placeholder: "Select network category",
      },
      purpose: {
        label: "Usage Purpose",
        placeholder: "Enter network usage purpose",
      },
      destinationType: {
        label: "Destination Type",
        placeholder: "Select destination type",
      },
      placeId: {
        label: "Destination Place",
        placeholder: "Select destination place",
      },
      deviceId: {
        label: "Destination Device",
        placeholder: "Select destination device",
      },
      next: "Next",
      submitting: "Submitting...",
    },
    step2: {
      title: "Access Control Management",
      accessLevel: {
        label: "Permission Type",
        placeholder: "Select permission type",
      },
      accessStatus: {
        label: "Access Status",
        placeholder: "Select access status",
      },
      accessPeriodFrom: {
        label: "Access Valid Period (From)",
        placeholder: "Enter access start date/time",
      },
      accessPeriodTo: {
        label: "Access Valid Period (To)",
        placeholder: "Enter access end date/time",
      },
      subjectType: {
        label: "Access Subject Type",
        placeholder: "Select access subject type",
      },
      back: "Back",
      submit: "Submit",
      submitting: "Submitting...",
    },
    stepper: {
      networkInformation: "Network Information",
      accessControl: "Access Control Management",
    },
    progressbar: {
      title: "Progress",
      totalFields: "Total Fields",
      requiredFields: "Required Fields",
      optionalFields: "Optional Fields",
      mustOnlyMode: "Must Only Mode",
      toggleMustOnly: "Toggle Must Only Mode",
      total: "Total",
      mustItem: "Required Items",
      filled: "Filled",
      modeSetting: "Input Mode Settings",
      mustItemOnly: "Required Items Only",
    },
    toast: {
      success: {
        title: "Success",
        description: "Network has been created successfully",
      },
      error: {
        title: "Error",
      },
      validationError: {
        title: "Input Error",
        description: "Please check required fields",
      },
    },
  },
  filters: {
    networkType: "Network Type",
    networkTypePlaceholder: "Search by network type",
    connectionType: "Wired/Wireless",
    connectionTypePlaceholder: "Search by wired/wireless",
    purpose: "Usage Purpose",
    destination: "Destination",
    networkTypeValues: {
      INTERNAL: "Internal",
      EXTERNAL: "External",
      VPN: "VPN",
      DEDICATED_LINE: "Dedicated Line",
      CLOUD: "Cloud",
    },
    connectionTypeValues: {
      WIRED: "Wired",
      WIRELESS: "Wireless",
      BOTH: "Both",
    },
    networkCategoryValues: {
      SHARED_INTERNAL: "Shared Internal Network",
      PERSONAL_USE: "Personal Use Network",
      COMPANY_ASSET: "Company Asset Network",
      CUSTOMER_ENVIRONMENT: "Customer Environment Network",
    },
    destinationTypes: {
      DEVICE: "Destination Device",
      PLACE: "Destination Place",
    },
  },
  detail: {
    sections: {
      networkInformation: "Network Basic Information",
      networkAccessControl: "Access Control Management",
      networkConnectionInformation: "Network Connection Information",
      networkConfiguration: "Network Configuration",
    },
    fields: {
      // Network Information fields
      networkName: "Network Name",
      networkCategory: "Network Category",
      networkType: "Network Type",
      connectionType: "Wired/Wireless",
      destinationType: "Destination Type",
      destinationDevice: "Destination Device",
      destinationPlace: "Destination Place",
      purpose: "Usage Purpose",
      adminContact: "Admin Manager",

      // Access Control fields
      accessStatus: "Access Status",
      accessLevel: "Permission Type",
      accessStartDate: "Access Valid Period (Start)",
      accessEndDate: "Access Valid Period (End)",
      subjectType: "Access Subject Type",

      // Connection Information fields
      ipAddress: "IP Address",
      networkStatus: "Communication Status",
      connectedWifi: "Connected Wi-Fi Name",
      mobileCarrier: "Carrier Name",
      simStatus: "SIM Status",
      iccid: "ICCID Number",

      // Configuration fields
      connectionProfile: "Connection SSID/VPN Name",
      proxySetting: "Proxy Setting",
      dnsServer: "DNS Setting",
      hostname: "Hostname",
    },
    destinationTypes: {
      device: "Destination Device",
      place: "Destination Place",
    },
    values: {
      accessStatus: {
        ACTIVE: "Active",
        INACTIVE: "Inactive",
        SUSPENDED: "Suspended",
        EXPIRED: "Expired",
      },
      accessLevel: {
        FULL_ACCESS: "Full Access",
        READ_ONLY: "Read Only",
        LIMITED: "Limited",
        NO_ACCESS: "No Access",
      },
      subjectType: {
        USER: "User",
        DEVICE: "Device",
        GROUP: "Group",
      },
      networkStatus: {
        CONNECTED: "Connected",
        OUT_OF_SERVICE: "Out of Service",
        ROAMING: "Roaming",
        DISCONNECTED: "Disconnected",
      },
      simStatus: {
        ACTIVE: "Active",
        INACTIVE: "Inactive",
        SUSPENDED: "Suspended",
        UNKNOWN: "Unknown",
      },
    },
  },
};

export default pagesNetworksEn;
